import { connectHook } from 'app/common/components/connect-hook';
import { NotFoundErrorContent } from './not-found-error-content';
import { useNotFoundErrorContent } from './not-found-error-content-hook';

export default connectHook(NotFoundErrorContent, useNotFoundErrorContent);
